module.exports = __webpack_public_path__ + "static/img/Ark.7162b8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/Ark.jpg
// module id = BHiL
// module chunks = 1